import React, {FC, PropsWithChildren} from 'react';
import {MemoizedEntry} from './entry';
import {EntryData} from './math';
import './style.css';

interface EntriesFormProps {
  entries: EntryData[];
}

export const EntriesForm: FC<PropsWithChildren<EntriesFormProps>> = ({
  entries,
}) => {
  return (
    <div className=" mb-10  grid grid-cols-1  gap-x-4 rounded-lg bg-gray-200 pt-3 pb-1 pl-3 shadow-lg min-[360px]:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
      {entries.map((entry, index) => (
        <MemoizedEntry
          key={`entry_${index}`}
          part1={entry.part1}
          part2={entry.part2}
          operator={entry.operator}
          hiddenElement={entry.hiddenElement}
          result={entry.result}
        />
      ))}
    </div>
  );
};
